
<div class="modal-backdrop-custom" (click)="onBackdropClick($event)"></div>

<div class="modal-wrapper" (click)="onBackdropClick($event)">
  <div class="modal-dialog">
    <button
      type="button"
      class="btn-close-custom"
      (click)="onCloseModal()"
      aria-label="Fechar"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>

    <img
      class="imagem-aviso"
      src="{{ BASE_IMG_URL }}assets/img/RDO_Banner_Novidade_Busca_por_Empresas.jpg"
      alt="A Busca por Empresas chegou à Rede de Obras"
      (click)="onImagemClick()"
    />
  </div>
</div>